// 询问方式枚举
export enum AskMode {
  AI = 1, // AI智能询问
  FIXED = 2, // 固定话术询问
}

// 固定话术配置
export interface FixAsk {
  content: string;
  items?: string[];
}

// 信息项
export interface InfoItem {
  id: string;
  name: string;
  desc: string;
  required: boolean;
  askMode: AskMode;
  fix_ask: FixAsk;
}

// 节点数据模型
export interface InfoExtractNodeData {
  infos: InfoItem[];
}

// 完整的节点模型
export interface Model {
  nodeData: InfoExtractNodeData;
} 